import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'btn-add-file',
	template: require('./btn-add-file.html'),
	styles: [require('./btn-add-file.scss')]
})
export class BtnAddFile {
	@Input() isActiveSpinner;
	@Input() files: File[];
	@Input() imageClass: string;
	@Input() jobId: number;
	@Output()
	saveFiles: EventEmitter<{ item; jobId }> = new EventEmitter<{
		item;
		jobId;
	}>();

	constructor(private messageService: MessageService) {}

	onSaveFiles(event): void {
		const values = [];
		const maxMb = 50; // 50 Mb
		const maxSize = maxMb * 1000 * 1024;
		const maxAllowedUploadFileSize = 20 * 1000 * 1024;

		Object.values(event.target.files).forEach(item => {
			if (item.size <= maxAllowedUploadFileSize) {
				values.push(item);
				const tmpDate = new Date(item.lastModifiedDate);
				const monthNames = [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'August',
					'September',
					'October',
					'November',
					'December'
				];
				item.customLastModifiedDate = `${tmpDate.getDate()} ${
					monthNames[tmpDate.getMonth()]
				} ${tmpDate.getFullYear()}`;
				item.convertedSize = (parseInt(item.size) / (1024 * 1024)).toFixed(2); // convert from bytes to MB
				this.saveFiles.emit({ item, jobId: this.jobId });
			} else if (maxSize > item.size && item.size > maxAllowedUploadFileSize) {
				this.messageService.showToaster('e_4', 'attachments');
			} else {
				this.messageService.showToaster('e_1', 'attachments');
			}
			event.target.value = '';
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/jobs/common/btn-add-file/btn-add-file.ts